<template>
    <Card :title="$t('labels.documents')">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th style="width: 100px">{{ $t('labels.actions') }}</th>
                        <th style="width: 100px">{{ $t('table.titles.id') }}</th>
                        <th>{{ $t('table.titles.name') }}</th>
                        <th style="width: 200px">{{ $t('table.titles.created_at') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(document, index) in documents" :key="document.uuid">
                        <td>
                            <AppButton size="sm" color="light" :icon="true" @click="deleteDocument(document.uuid, index)">
                                <i class="icon-trash"></i>
                            </AppButton>
                        </td>
                        <td>{{ document.id }}</td>
                        <td>
                            <a :href="document?.file?.url ?? null">
                                <i class="icon-file-pdf mr-2"></i>
                                <span>{{ document?.file?.name ?? $t('labels.without_name') }}</span>
                            </a>
                        </td>
                        <td>{{ document.created_at }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton size="sm" color="teal" @click="$refs.CreateDocumentModal.show()">
                <span>{{ $t('buttons.create') }}</span>
            </AppButton>
        </div>
    </Card>
    <CreateDocumentModal
        ref="CreateDocumentModal"
        :exit-declaration="exitDeclaration"
        @created="documentCreated"
    />
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';
import CreateDocumentModal from '../modals/CreateDocumentModal.vue';
import { httpClient } from '../../../../../services/HttpClient';
export default {
    name: 'DocumentCard',
    components: {
        Card, AppButton, CreateDocumentModal
    },
    props: {
        exitDeclaration: {
            type: Object,
            required: true
        }
    },
    emits: ['document-created'],
    data() {
        return {
            documents: []
        }
    },
    methods: {
        documentCreated(document) {
            this.$emit('document-created', document);
            this.fetchDocuments();
        },
        fetchDocuments() {
            let documents = Object.keys(this.exitDeclaration?.files ?? {});

            if (documents.length === 0) {
                this.documents = [];
                return;
            }

            httpClient.get('/file/documents', {
                uuids: documents,
                extra: 1
            }).then((response) => {
                this.documents = response.data.data;
            });
        },
        deleteDocument(uuid, index) {
            this.documents.splice(index, 1);
            httpClient.delete(`/file/documents/${uuid}`).then(() => {
                let files = this.documents.map(document => ({ document_uuid: document.uuid, url: document.file.url }));

                httpClient.patch(`/projects/${this.$route.params.projectUuid}/management/exit-declarations/${this.exitDeclaration.uuid}`, {
                    files: files
                });

                this.fetchDocuments();
            });
        }
    },
    mounted() {
        this.fetchDocuments();
    }
};
</script>
